var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3676_15127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -1,
    width: 18,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99915 7.99943H7.99957C8.55209 7.99943 8.99999 7.55153 8.99999 6.99901C8.99999 6.4465 8.55209 5.99859 7.99957 5.99859H6.99915C6.44664 5.99859 5.99874 6.4465 5.99874 6.99901C5.99874 7.55153 6.44664 7.99943 6.99915 7.99943ZM6.99915 10.0003C6.44664 10.0003 5.99874 10.4482 5.99874 11.0007C5.99874 11.5532 6.44664 12.0011 6.99915 12.0011H13.0017C13.5542 12.0011 14.0021 11.5532 14.0021 11.0007C14.0021 10.4482 13.5542 10.0003 13.0017 10.0003H6.99915ZM18.0037 6.93899C17.9933 6.84708 17.9732 6.75654 17.9437 6.66887V6.57884C17.8956 6.47597 17.8314 6.38142 17.7536 6.29872L11.7511 0.296219C11.6684 0.218403 11.5739 0.154241 11.471 0.10614C11.4412 0.101898 11.4108 0.101898 11.381 0.10614C11.2794 0.0478567 11.1671 0.0104439 11.0508 -0.00390625H4.99832C3.34078 -0.00390625 1.99707 1.3398 1.99707 2.99734V17.0032C1.99707 18.6607 3.34078 20.0044 4.99832 20.0044H15.0025C16.66 20.0044 18.0037 18.6607 18.0037 17.0032V6.99901C18.0037 6.99901 18.0037 6.99901 18.0037 6.93899ZM12.0012 3.40751L14.5923 5.99859H13.0017C12.4491 5.99859 12.0012 5.55069 12.0012 4.99818V3.40751ZM16.0029 17.0032C16.0029 17.5557 15.555 18.0036 15.0025 18.0036H4.99832C4.44581 18.0036 3.9979 17.5557 3.9979 17.0032V2.99734C3.9979 2.44483 4.44581 1.99693 4.99832 1.99693H10.0004V4.99818C10.0004 6.65572 11.3441 7.99943 13.0017 7.99943H16.0029V17.0032ZM13.0017 14.0019H6.99915C6.44664 14.0019 5.99874 14.4498 5.99874 15.0023C5.99874 15.5549 6.44664 16.0028 6.99915 16.0028H13.0017C13.5542 16.0028 14.0021 15.5549 14.0021 15.0023C14.0021 14.4498 13.5542 14.0019 13.0017 14.0019Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3676_15127)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.8f658cd169b622189312a9dc4608af42.svg";
export { ForwardRef as ReactComponent };